<template>
  <div>
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Автопроверенные приходы</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <RoamingInvoiceList ref="roamingInvoiceList"
                        :invoices="dataTable.invoices"
                        :total="dataTable.total"
                        :limitOptions="dataTable.limitOptions"
                        :filters.sync="dataTable.filters"
                        :pagination.sync="dataTable.pagination"
                        :allow-sign-all-button="true"
                        :allow-sign-button-fn="allowSignButton"
                        :allow-decline-button-fn="allowDeclineButton"
                        :sign-all-button-disabled-state="signAllButtonDisabledState"
                        :disable-not-allowed-sign-button="false"
                        :disable-not-allowed-decline-button="false"
                        :allow-branch-filter="true"
                        :show-created-at="true"
                        @load="onLoad"
                        @sign-all="onSignAll"
                        @sign="onSign"
    />

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!--EImzo snackbars-->
    <v-snackbar
        v-model="eimzoFailedSnackbar"
        top
        :timeout="3000"
        color="error"
        :counter="9"
    >
      Ошибка с EImzo
      <v-btn
          color="white"
          text
          @click="eimzoFailedSnackbar = false"
      >
        Закрыть
      </v-btn>
    </v-snackbar>

    <!--sign snackbars-->
    <v-snackbar
        v-model="signSuccessSnackbar"
        top
        :timeout="3000"
        color="success"
        :counter="9"
    >
      Документ успешно подписан
      <v-btn
          color="white"
          text
          @click="signSuccessSnackbar = false"
      >
        Закрыть
      </v-btn>
    </v-snackbar>
    <v-snackbar
        v-model="signFailedSnackbar"
        top
        :timeout="3000"
        color="error"
        :counter="9"
    >
      Ошибка при подписании документа
      <v-btn
          color="white"
          text
          @click="signFailedSnackbar = false"
      >
        Закрыть
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import RoamingInvoiceList from '@/components/main/roaming/RoamingInvoiceList'
import InvoiceService from '@/services/invoice.service'
import SignService from '@/services/sign/sign.service'
import _ from 'underscore'
import moment from 'moment'
import eImzo from '@/plugins/eimzo'

export default {
  components: {
    RoamingInvoiceList
  },
  name: "RoamingIncomeMatchBox",

  data() {
    return {
      dataTable: {
        invoices: [],
        total: 0,
        limitOptions: [10, 20, 30, 50, 100, 200, 500],
        filters: {
          invoiceNumber: '',
          invoiceDate: null,
          contractor: '',
          branch: null
        },
        pagination: {
          page: 1,
          limit: 10
        }
      },

      loading: false,

      signSuccessSnackbar: false,
      signFailedSnackbar: false,
      eimzoFailedSnackbar: false,
    };
  },

  methods: {
    /*handlers*/
    onLoad() {
      this.load();
    },
    onSignAll() {
      this.iterateSign(this.dataTable.invoices, 0);
    },
    onSign(invoice) {
      this.loading = true;

      SignService.getFakturaHashCode(invoice.documentUniqueId)
          .then(getFakturaHashCodeResponse => {
            if (getFakturaHashCodeResponse.data
                && getFakturaHashCodeResponse.data.HashCodeDetail
                && getFakturaHashCodeResponse.data.HashCodeDetail.FakturaHashCode
                && getFakturaHashCodeResponse.data.HashCodeDetail.RoamingContractorHashCode
            ) {
              const fakturaHashCode = getFakturaHashCodeResponse.data.HashCodeDetail.FakturaHashCode;
              const roamingHashCode = getFakturaHashCodeResponse.data.HashCodeDetail.RoamingContractorHashCode;

              const timestampFn = (signatureHex) => {
                return new Promise((resolve, reject) => {
                  SignService.getTimeStamp(signatureHex)
                      .then(getTimeStampResponse => {
                        resolve(getTimeStampResponse.data);
                      }, reject);
                });
              };

              eImzo.signByAttach(fakturaHashCode, roamingHashCode, this.$store.getters.certificate, timestampFn)
                  .then(result => {
                    const signResult = result[0];
                    const attachTimestampResult = result[1];

                    SignService.signKorzinkaRoamingDocument({
                      fakturaUniqueId: invoice.documentUniqueId,
                      fakturaPkcs7: signResult.pkcs7,
                      roamingPkcs7: attachTimestampResult.pkcs7,
                      certificateSerial: attachTimestampResult.signerSeriaNumber,
                      actNumber: invoice.actNumber
                    })
                        .then(response => {
                          if (response.data === 0)
                            this.signDocumentSuccess(invoice);
                          else
                            this.signDocumentFailed(invoice);

                          this.loading = false;

                          this.load();
                        }, () => {
                          this.signDocumentFailed(invoice);
                          this.loading = false;
                        });
                  }, () => {
                    this.signDocumentEImzoError(invoice);
                    this.loading = false;
                  });
            } else {
              this.signDocumentHashCodeError();
              this.loading = false;
            }
          })
          .catch(() => {
            this.signDocumentHashCodeError();
            this.loading = false;
          });
    },

    iterateSign(invoices, iterationIndex) {
      this.loading = true;
      if (iterationIndex < invoices.length) {
        const invoice = invoices[iterationIndex];

        SignService .getFakturaHashCode(invoice.documentUniqueId)
            .then(getFakturaHashCodeResponse => {
              if (getFakturaHashCodeResponse.data
                  && getFakturaHashCodeResponse.data.HashCodeDetail
                  && getFakturaHashCodeResponse.data.HashCodeDetail.FakturaHashCode
                  && getFakturaHashCodeResponse.data.HashCodeDetail.RoamingContractorHashCode
              ) {
                const fakturaHashCode = getFakturaHashCodeResponse.data.HashCodeDetail.FakturaHashCode;
                const roamingHashCode = getFakturaHashCodeResponse.data.HashCodeDetail.RoamingContractorHashCode;

                const timestampFn = (signatureHex) => {
                  return new Promise((resolve, reject) => {
                    SignService.getTimeStamp(signatureHex)
                        .then(getTimeStampResponse => {
                          resolve(getTimeStampResponse.data);
                        }, reject);
                  });
                };

                eImzo.signByAttach(fakturaHashCode, roamingHashCode, this.$store.getters.certificate, timestampFn)
                    .then(result => {
                      const signResult = result[0];
                      const attachTimestampResult = result[1];

                      SignService.signKorzinkaRoamingDocument({
                        fakturaUniqueId: invoice.documentUniqueId,
                        fakturaPkcs7: signResult.pkcs7,
                        roamingPkcs7: attachTimestampResult.pkcs7,
                        certificateSerial: attachTimestampResult.signerSeriaNumber,
                        actNumber: invoice.actNumber
                      })
                          .then(response => {
                            if (response.data === 0)
                              this.signDocumentSuccess(invoice);
                            else
                              this.signDocumentFailed(invoice);
                            this.iterateSign(invoices, iterationIndex + 1);
                          }, () => {
                            this.signDocumentFailed(invoice);
                            this.iterateSign(invoices, iterationIndex + 1);
                          });
                    }, () => {
                      this.signDocumentEImzoError(invoice);
                      this.iterateSign(invoices, iterationIndex + 1);
                    });
              } else {
                this.signDocumentFailed(invoice);
                this.iterateSign(invoices, iterationIndex + 1);
              }
            })
            .catch(() => {
              this.signDocumentFailed(invoice);
              this.iterateSign(invoices, iterationIndex + 1);
            });

      } else {
        this.loading = true;
        this.load();
      }
    },

    signDocumentSuccess() {
      this.signSuccessSnackbar = true;
    },
    signDocumentFailed() {
      this.signFailedSnackbar = true;
    },
    signDocumentEImzoError() {
      this.eimzoFailedSnackbar = true;
    },

    allowSignButton() {
      return this.$store.getters.isCertificateLoaded;
    },
    allowDeclineButton() {
      return false;
    },
    signAllButtonDisabledState() {
      return this.dataTable.invoices.length  === 0 || !this.$store.getters.isCertificateLoaded;
    },

    load() {
      this.loading = true;

      let skip = (this.dataTable.pagination.page - 1) * this.dataTable.pagination.limit;
      skip = skip < 0 ? 0 : skip;

      InvoiceService.roamingIncomeMatchDocumentsMeta({
        limit: this.dataTable.pagination.limit,
        skip: skip,
        contractor: this.dataTable.filters.contractor,
        invoiceDate: this.dataTable.filters.invoiceDate ? moment(this.dataTable.filters.invoiceDate, 'YYYY-MM-DD') : null,
        invoiceNumber: this.dataTable.filters.invoiceNumber,
        branch: this.dataTable.filters.branch ? this.dataTable.filters.branch.id : null
      })
          .then(response => {
            if (this.loading) {
              this.dataTable.invoices = _.map(response.data.Records, i => {
                return {
                  documentUniqueId: i.DocumentUniqueId,
                  invoiceNumber: `${i.InvoiceNumber} *** ${i.SystemInvoiceNumber}`,
                  systemInvoiceNumber: i.SystemInvoiceNumber,
                  invoiceDate: i.InvoiceDate,
                  invoiceTotal: i.InvoiceTotal,
                  contractorInn: i.ContractorInn,
                  contractorName: i.ContractorName,
                  actNumber: i.ActNumber,
                  branchName: i.BranchName,
                  createdOn: i.CreatedAt
                };
              });
              this.dataTable.total = response.data.Total;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
  }
}
</script>

<style scoped>

</style>